module.exports = __webpack_public_path__ + "img/logo.afbed980.png";